import dayjs from 'dayjs';

export function startOfMonth(inputDate) {
  const date = inputDate || dayjs();
  return date.date(1).hour(0).minute(0).second(0).millisecond(0);
}
